import moment from "moment";

const readingInterval = (dateTime) => {
  if (!dateTime) return 9999;
  const readingDateTime = moment(dateTime, [
    "YYYY-MM-DD HH:mm:ss",
    "YYYY-MM-DDTHH:mm:ss",
    "DD/MM/YYYY HH:mm:ss",
  ]);
  if (!readingDateTime.isValid()) return 9999;
  const currentDateTime = moment();
  return Math.abs(currentDateTime.diff(readingDateTime, "minutes"));
};

export const isDisconnected = (dateTime) =>
  readingInterval(dateTime) > 10 || dateTime == null;
